import { IndexedService, NOTES_STORE } from '@damofire/data-commons';
import { NetworkService } from '@damofire/data-angular-commons';
import { Injectable } from '@angular/core';
import { RemoteService } from './remote.service';
import { Note } from '../../note/note.dto';
import { FirebaseNoteService } from '../../note/firebase-note.service';

@Injectable()
export class NoteRemoteService extends RemoteService<Note> {
  constructor(
    protected readonly idbService: IndexedService,
    protected readonly networkService: NetworkService,
    private readonly firebaseNoteService: FirebaseNoteService,
  ) {
    super(NOTES_STORE, idbService, networkService);
  }

  async add(division: string, data: Note[]): Promise<void> {
    await this.firebaseNoteService.create(data);
  }

  async delete(division: string, data: Note[]): Promise<void> {
    for (const note of data) {
      await this.firebaseNoteService.delete(division, note._id);
    }
  }

  async update(division: string, data: Note[]): Promise<void> {
    for (const note of data) {
      await this.firebaseNoteService.update(note, note.text);
    }
  }
}
